import { FC, ReactNode } from 'react';

import { GTMProvider } from '@eneco/tracking';
import type { DC_Repositories_Base_Enumerations_BusinessUnit } from '@monorepo-types/dc';

export type CmsGTMProviderProps = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  children: ReactNode;
};

export const CmsGTMProvider: FC<CmsGTMProviderProps> = ({ businessUnit, children }) => (
  <GTMProvider businessUnit={businessUnit} useLegacy={businessUnit !== 'nl'}>
    {children}
  </GTMProvider>
);
